module.exports = __webpack_public_path__ + "static/media/color-ceiling.1a61d5e0.gif";